export default {
    title: 'ប្រព័ន្ធផ្ទុកលើពពក',
    cloud_hosting: 'ប្រព័ន្ធផ្ទុកលើពពក',
    cloud_hosting_extend: 'ពង្រីកប្រព័ន្ធផ្ទុកលើពពក',
    cloud_hosting_upgrade: 'ធ្វើបច្ចុប្បន្នភាព Cloud Hosting',
    credentials: 'ប័ណ្ណសម្គាល់',
    service_package: 'កញ្ចប់សេវាកម្ម',
    invoice_id: 'លេខសម្គាល់វិក័យប័ត្រ',
    machine_name: 'ឈ្មោះម៉ាស៊ីន',
    reg_date: 'កាលបរិច្ឆេទ​ចុះឈ្មោះ',
    due_date: 'កាលបរិច្ឆេទ​ផុត​កំណត់',
    server_status: 'ស្ថានភាពម៉ាស៊ីនមេ',
    server_package_status: 'ស្ថានភាពនៃកញ្ចប់',
    server_name: 'ឈ្មោះម៉ាស៊ីនមេ',
    project_name: 'ឈ្មោះគម្រោង',
    package_status: 'ស្ថានភាពកញ្ចប់',
    specifications: 'លក្ខណៈបច្ចេកទេស',
    ip: 'IP សាធារណៈ',
    additional_ip: 'IP បន្ថែម',
    additional_file_storage: 'ការផ្ទុកឯកសារបន្ថែម',
    additional_database_storage: 'ការផ្ទុកមូលដ្ឋានទិន្នន័យបន្ថែម',
    username: 'ឈ្មោះអ្នកប្រើ Cloud Panel',
    terminal_username: 'ឈ្មោះអ្នកប្រើស្ថានីយ',
    password: 'ពាក្យសម្ងាត់',
    cloud_hosting_detail: 'Cloud Hosting លម្អិត',
    dashboard: 'ផ្ទាំងគ្រប់គ្រង',
    cloud_hosting_info: 'ព័ត៌មាន ប្រព័ន្ធផ្ទុកលើពពក',
    order_code: 'លេខកូដបញ្ជាទិញ',
    cloud_hosting_package: 'កញ្ចប់ប្រព័ន្ធផ្ទុកលើពពក',
    application: 'ការដាក់ពាក្យ',
    payment_plan: 'គម្រោងទូទាត់',
    action: 'សកម្មភាព',
    cloud_panel: 'ផ្ទាំងពពក',
    reset_warning:
        'វា​នឹង​កំណត់​ឡើង​វិញ អ្នក​នឹង​បាត់​បង់​ទិន្នន័យ​ដែល​មាន​​ទាំង​អស់​នៅ​លើ​ម៉ាស៊ីន​មេ​នេះ តើ​អ្នក​ចង់បន្ត​ឬ​ទេ?',
    package_addons: {
        storage: 'Storage',
    },
    cloud_hosting_reset_failed: 'កំណត់ឡើងវិញ បានបរាជ័យ។ សូម ព្យាយាម ម្តង ទៀត។',
    auto_renew: 'បន្តដោយស្វ័យប្រវត្តិ',
    upgrade_warning:
        'អ្នក ត្រូវ បង់ ប្រាក់ បញ្ជា ទិញ នេះ ក្នុង មួយ ថ្ងៃ បើ មិន ដូច្នេះ ទេ ការ បញ្ជា ទិញ នឹង ត្រូវ បាន លុប',
    package_name: 'មោះកញ្ចប់',
    change_terminal_password: 'ផ្លាស់ប្តូរពាក្យសម្ងាត់របស់ Terminal',
    change_panel_password: 'ផ្លាស់ប្តូរពាក្យសម្ងាត់របស់ Panel',
};
